import { CommandItem } from "@/components/atoms/Command";
import { Paragraph } from "@/components/atoms/Paragraph";
import type { IPopularAppsSuggestionsListProps } from "@/components/molecules/MainSearch/types";

const PopularAppsSuggestionsList = ({
  popularAppsList = [],
  onClickHandler,
}: IPopularAppsSuggestionsListProps) => {
  return (
    <>
      {popularAppsList.map(({ id, name, alias }) => {
        return (
          <CommandItem
            key={id}
            value={alias}
            onSelect={onClickHandler}
            className="cursor-pointer data-[selected=true]:bg-primary-light data-[selected=true]:text-primary-selected"
          >
            <Paragraph size="small" fontWeight="regular">
              {name}
            </Paragraph>
          </CommandItem>
        );
      })}
    </>
  );
};

export default PopularAppsSuggestionsList;
